import moment from "moment";
import { FRACTION_DIGITS } from "../constants";
import { reportingCurrencies } from "../metadata/localOptions";

export const formatMoneyValue = (x: number) => {
  const options = !Number.isInteger(x)
    ? {
        minimumFractionDigits: FRACTION_DIGITS,
        maximumFractionDigits: FRACTION_DIGITS
      }
    : {};
  const curr = (window as any).currency;
  let currSymbol = "$";
  if (curr) {
    const index = reportingCurrencies.findIndex(
      currencies => currencies.code.toLowerCase() === curr.toLowerCase()
    );
    if (index > -1) {
      currSymbol = reportingCurrencies[index].symbol;
    }
  }

  const value = x.toLocaleString(undefined, options);
  return `${currSymbol}${value}`;
};

export const formatDate = (date: moment.Moment) =>
  date.format("MMM DD YYYY  HH:mm");



// WEBPACK FOOTER //
// ./src/utils/formatters.ts